export default __webpack_public_path__ + "static/media/survey3.60b8f56c.svg";